import { request } from '@umijs/max';

const TOKEN_KEY = 'erp_token';
const SESSION_KEY = 'erp_session_id';

export function saveToken(token?: string, sessionId?: string) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  }
  if (sessionId) {
    localStorage.setItem(SESSION_KEY, sessionId);
  }
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(SESSION_KEY);
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function getSessionId() {
  return localStorage.getItem(SESSION_KEY);
}

export function saveSessionId(sessionId?: string) {
  if (sessionId) localStorage.setItem(SESSION_KEY, sessionId);
}

export async function getWecomLoginConfig() {
  return request<{ success: boolean; data: API.WecomLoginConfig }>(
    '/api/auth/wecom/config',
    { method: 'GET', skipErrorHandler: true },
  );
}

export async function getWecomOAuthUrl(redirectUri: string) {
  return request<{
    success: boolean;
    data: { url: string; scope: string };
  }>('/api/auth/wecom/oauth-url', {
    method: 'GET',
    params: { redirectUri },
    skipErrorHandler: true,
  });
}

export async function loginByWecom(
  body: API.WecomLoginParams,
  options?: { skipErrorHandler?: boolean },
) {
  return request<API.LoginResult>('/api/auth/wecom/login', {
    method: 'POST',
    data: body,
    skipErrorHandler: options?.skipErrorHandler,
  });
}

export async function searchVerifyAccounts(name: string) {
  return request<{
    success: boolean;
    data: {
      list: Array<{
        id: string;
        name: string;
        username: string;
        department: string;
        channels: Array<'wecom' | 'email'>;
        hints: { wecom?: string; email?: string };
      }>;
    };
  }>('/api/auth/verify-code/accounts', {
    method: 'GET',
    params: { name },
    skipErrorHandler: true,
  });
}

export async function sendVerifyLoginCode(body: {
  userId: string;
  channel: 'wecom' | 'email';
}) {
  return request<{
    success: boolean;
    data: {
      ok: boolean;
      message: string;
      channel: string;
      hint: string;
      expiresInMinutes: number;
    };
  }>('/api/auth/verify-code/send', {
    method: 'POST',
    data: body,
  });
}

export async function loginByVerifyCode(body: {
  userId: string;
  code: string;
}) {
  return request<API.LoginResult>('/api/auth/verify-code/login', {
    method: 'POST',
    data: body,
  });
}

export async function sendVerifyCodeByEmail(email: string) {
  return request<{
    success: boolean;
    data: {
      ok: boolean;
      message: string;
      channel: string;
      hint: string;
      expiresInMinutes: number;
    };
  }>('/api/auth/verify-code/send-by-email', {
    method: 'POST',
    data: { email },
  });
}

export async function loginByVerifyCodeEmail(body: {
  email: string;
  code: string;
}) {
  return request<API.LoginResult>('/api/auth/verify-code/login-by-email', {
    method: 'POST',
    data: body,
  });
}

/** 开发者代领他人登录验证码（不发企微/邮件，仅超管 + 二次密码） */
export async function issueDevVerifyCode(
  email: string,
  confirmPassword: string,
) {
  return request<{
    success: boolean;
    data: {
      ok: boolean;
      code: string;
      expiresInMinutes: number;
      expiresAt: string;
      user: {
        id: string;
        name: string;
        username: string;
        email: string;
      };
      message: string;
    };
  }>('/api/erp/dev/impersonate-verify-code', {
    method: 'POST',
    data: { email, confirmPassword },
  });
}

export async function getDevImpersonateStatus() {
  return request<{
    success: boolean;
    data: { configured: boolean; updatedAt: string | null };
  }>('/api/erp/dev/impersonate-status', { method: 'GET' });
}

export async function setDevImpersonatePassword(body: {
  password: string;
  currentPassword?: string;
}) {
  return request<{
    success: boolean;
    data: { configured: boolean; updatedAt: string };
  }>('/api/erp/dev/impersonate-password', {
    method: 'PUT',
    data: body,
  });
}

export async function sendEmailLoginCode(email: string) {
  return request<{
    success: boolean;
    data?: { ok: boolean; message: string; email: string };
  }>('/api/auth/email-code/send', {
    method: 'POST',
    data: { email },
  });
}

export async function loginByEmailCode(body: { email: string; code: string }) {
  return request<API.LoginResult>('/api/auth/email-code/login', {
    method: 'POST',
    data: body,
  });
}
